<template>
  <v-card>
    <v-toolbar dark color="primary">
      <v-btn icon dark @click="$emit('close-dialog')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>{{ $t('components.AI.AiPlanCreator.title') }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text class="pa-4">
      <div class="d-flex align-start">
        {{ $t('components.AI.AiPlanCreator.greeting') }}
      </div>
      <v-textarea
        v-model="userRequirements"
        outlined
        :label="$t('components.AI.AiPlanCreator.describeRequirements')"
        :placeholder="$t('components.AI.AiPlanCreator.enterRequirements')"
        rows="4"
        class="mt-4"
      ></v-textarea>
      <div class="text-right">
        <v-btn
          color="primary"
          class="mt-4"
          :disabled="!userRequirements"
          @click="submitRequest"
        >
          {{ $t('components.AI.AiPlanCreator.next') }}
        </v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data () {
    return {
      userRequirements: ''
    }
  },
  methods: {
    async submitRequest () {
      try {
        console.log('User Requirements:', this.userRequirements)
        console.log('Plan Details:', this.planDetails)
        const response = await this.$store.dispatch('ai/generatePlanOptimization', {
          planDetails: this.planDetails.mediaChannels,
          userRequirements: this.userRequirements,
          systemPrompt: 'You will receive: 1. A paragraph with information about an optimization plan that a client wants to implement for our MMM platform. 2. A list of media channels available for the current model. Based on the information provided in the paragraph, you must generate useful data for creating the plan for the current model. This data will follow a strict JSON format. To achieve this, you will be guided through various steps that you must follow and respond to in a JSON format, as instructed internally. This is de data to be present inside the JSOn response: - "Plan name" - "Start Date" (In YYYY-MM-DD format) - "End Date": (In YYYY-MM-DD format) - "Budget": (Currency amount) - "Restrictions": An object with a key for every media channel previously given. Each media channel shall have two numeric values, indicating the min and max amounts allowed as investment for that channel. These values are keyed as "min" and "max". Important: If a total investment amount is provided for a set of media, ensure it is distributed correctly. Be cautious with orders of magnitude when calculating percentages.'
        })
        console.log('AI Response:', response)
      } catch (error) {
        console.error('Error submitting request:', error)
      } finally {
        this.$emit('close-dialog')
      }
    }
  },
  props: {
    planDetails: {
      type: Object,
      required: true
    }
  }
}
</script>
